import styled, { css } from 'styled-components'
import { breakpoint } from 'utils'

export const SearchBarWrapper = styled.div`
  min-width: 320px;
  width: 100%;
  margin-left: 8px;
  margin-right: 24px;

  ${breakpoint('md')`
    width: 480px;
  `}

  form {
    max-width: initial;
  }
`

export const ViewAsText = styled.span(
  ({ theme }) => css`
    flex-shrink: 0;
    margin-right: 8px;
    color: ${theme.colors.foreground.secondary[4]};
    font-size: ${theme.fontSizes.smaller};
  `
)
